import type { TFunction, TOptionsBase } from 'i18next';
import { useTranslation } from 'react-i18next';

import type { SitecoreTranslation, TranslationKey } from '~/models';

const sitecoreTranslation = (value: SitecoreTranslation): TOptionsBase => ({
  ...value,
  interpolation: {
    prefix: '{',
    suffix: '}',
  },
});

const translateKey = (key: string, t: TFunction, interpolationOptions?: SitecoreTranslation) => {
  if (typeof interpolationOptions === 'undefined') {
    return t(key);
  }

  return t(key, sitecoreTranslation(interpolationOptions));
};

export function useTranslationByKey(): (
  key: TranslationKey,
  interpolationOptions?: SitecoreTranslation,
) => string {
  const [t] = useTranslation();

  return (key: string, interpolationOptions?: SitecoreTranslation) =>
    translateKey(key, t, interpolationOptions);
}
